import { useMemo, useState } from "react";
import styled from "styled-components";
import GalleryFilter from "../components/gallery/GalleryFilter";
import GalleryItem from "../components/gallery/GalleryItem";
import Collection from "../config/NFTCollection";
//https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/1.png

const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  column-gap: 8px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
`;

const GalleryInner = styled.div`
  display: grid;
  grid-template-columns: repeat(3,1fr);
  column-gap: 24px;
  row-gap:16px;
  @media (max-width: 992px) {
    grid-template-columns: repeat(2,1fr);
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}
`;

const Gallery = () => {
  const [checked, setChecked] = useState([]);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const filterList = useMemo(() => {
    if (!checked.length) {
      return Collection;
    }

    return Collection.filter((item) => {
      return checked.findIndex((m) => m === item.categoryId) > -1;
    });
  }, [checked]);

  const resetFilter = () => {
    setChecked([]);
  };

  const renderGalleryItem = () => {
    return filterList.map((item) => <GalleryItem item={item} key={item.id} />);
  };

  return (
    <div
      className="container"
      style={{
        marginTop: window.innerWidth > 768 ? 120 : 75,
        paddingBottom: 50,
      }}>
      <div className="heading h3">Galeri</div>
      <GalleryContainer>
        <GalleryFilter
          handleToggle={handleToggle}
          resetFilter={resetFilter}
          checkList={checked}
        />
        <GalleryInner>{renderGalleryItem()}</GalleryInner>
      </GalleryContainer>
    </div>
  );
};

export default Gallery;
